var React = require('react');

function ArrowMenuInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Polygon_6","data-name":"Polygon 6","d":"M2.5,0,5,4H0Z","fill":"#7d858e"}));
}

ArrowMenuInline.defaultProps = {"width":"5","height":"4","viewBox":"0 0 5 4"};

module.exports = ArrowMenuInline;

ArrowMenuInline.default = ArrowMenuInline;
